import React from "react";
import { Col, Button, Modal, Image, Row } from "react-bootstrap";
export const ProvideNewOfferModal = ({
  isOpen,
  onHide,
  nextButton,
  selectOffer,
  offer,
}) => {
  let OfferOptionArray = [
    "Yes, I would like to offer a new booking request",
    `No, I do  not wish to offer a new booking request`,
  ];
  return (
    <div>
      <Modal
        size="lg"
        className="ProfileStatus-modal decline-modal"
        show={isOpen}
        onHide={onHide}
      >
        <Modal.Body>
          <Row>
            <Col
              lg={12}
              md={12}
              sm={12}
              xs={12}
              style={{ padding: "10px 40px", textAlign: "justify" }}
            >
              <div
                className="cancel-btn flex-center-center"
                onClick={onHide}
                style={{
                  fontSize: "17px",
                  width: "30px",
                  height: "30px",
                  marginTop: "20px",
                }}
              >
                <i className="mdi mdi-close"></i>
              </div>
              <div style={{ marginBottom: "50px" }} />
              <h3>Would you like to send Mawuli a special offer to book?</h3>
              <div className="modal-para" style={{ marginBottom: "15px" }}>
                You can offer Mawuli a new booking request based on a desirable
                rate, availability, frequency, lesson duration, start time or
                start date of lesson
              </div>
              <div className="flex" style={{ flexDirection: "column" }}>
                {OfferOptionArray.length
                  ? OfferOptionArray.map((question, i) => (
                      <div className="custom-control custom-radio custom-control-inline radio-decline-status">
                        <input
                          type="radio"
                          id={`customRadioInline${i}`}
                          name={`customRadioInline0`}
                          className="custom-control-input"
                          checked={offer === i}
                        />
                        <label
                          className="custom-control-label common-para"
                          htmlFor={`customRadioInline${i}`}
                          onClick={() => selectOffer(i === 0 ? "yes" : "no", i)}
                          style={{ color: "#1c1c1c" }}
                        >
                          {question}
                        </label>
                      </div>
                    ))
                  : "no data"}
              </div>
              <div
                className="flex-between-center"
                style={{ marginTop: "30px" }}
              >
                <div
                  className="green-txt flex-center"
                  onClick={onHide}
                  style={{
                    width: "16px",
                    paddingBottom: "2px",
                    fontFamily: "CircularStdMedium, Arial, sans-serif",
                    fontSize: "16px",
                    fontWeight: "normal",
                    fontStretch: "normal",
                    fontStyle: "normal",
                  }}
                >
                  <Image
                    src={require("./../../../assets/icons/back-left.png")}
                    style={{
                      width: "14px",
                    }}
                  />
                  Back
                </div>
                <Button
                  className="green-Button"
                  style={{
                    width: "126px",
                    height: "45px",
                    backgroundColor: "#2cb46d",
                    fontFamily: "CircularStdMedium, Arial, sans-serif",
                    fontSize: "16px",
                    fontWeight: "normal",
                    fontStretch: "normal",
                    fontStyle: "normal",
                    color: "#ffffff",
                  }}
                  onClick={nextButton}
                >
                  Next
                </Button>
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </div>
  );
};
